module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/usnavyflag.083dbea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/usnavyflag.jpg
// module id = zGVc
// module chunks = 0